import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faPlaneDeparture, faFileAlt, faUserCheck, faHospital } from "@fortawesome/free-solid-svg-icons";

const Timeline = () => {
  const manpowerTimeline = [
    { id: 1, title: "Client Requirement" },
    { id: 2, title: "Analysis" },
    { id: 3, title: "Sourcing" },
    { id: 4, title: "Screening" },
    { id: 5, title: "Skill/Trade Test" },
    { id: 6, title: "Selection" },
  ];

  const mobilizationTimeline = [
    {
      id: 1,
      title: "Interview of the Candidates",
      icon: faUserCheck,
      description: "Candidates are interviewed to assess their qualifications and suitability for the position.",
    },
    {
      id: 2,
      title: "Online Registration",
      icon: faFileAlt,
      description: "Candidates complete the mandatory online registration process with accurate details.",
    },
    {
      id: 3,
      title: "Medical Test (Unfit/Fit)",
      icon: faHospital,
      description: "Candidates undergo a medical examination to determine their health status (fit or unfit).",
    },
    {
      id: 4,
      title: "Employer Applies for Visa Approval Layer",
      icon: faFileAlt,
      description: "The employer submits an application for visa approval to the respective authorities.",
    },
    {
      id: 5,
      title: "Approval Layer Received",
      icon: faCheckCircle,
      description: "The visa approval layer is received from the concerned authority.",
    },
    {
      id: 6,
      title: "Submit Passport to Embassy",
      icon: faFileAlt,
      description: "Passports are submitted to the embassy for visa stamping and related formalities.",
    },
    {
      id: 7,
      title: "Passport Received from Embassy",
      icon: faCheckCircle,
      description: "Passports are returned from the embassy with the necessary visa stamped.",
    },
    {
      id: 8,
      title: "3 Days BMET Training",
      icon: faFileAlt,
      description: "Candidates attend a mandatory 3-day training program conducted by BMET.",
    },
    {
      id: 9,
      title: "Permission from Ministry of Expatriates",
      icon: faFileAlt,
      description: "Permission is obtained from the Ministry of Expatriates for final clearance.",
    },
    {
      id: 10,
      title: "Emigration Clearance from BMET",
      icon: faFileAlt,
      description: "The emigration clearance process is completed through BMET.",
    },
    {
      id: 11,
      title: "Worker Ready to Fly",
      icon: faPlaneDeparture,
      description: "The worker completes all formalities and is ready to travel to the destination.",
    },
  ];

  return (
    <div className="py-16 bg-black text-white">
      {/* Horizontal Timeline */}
      <div className="mb-16 ">
  <div className="flex flex-wrap justify-center items-center space-x-4 gap-2">
    {manpowerTimeline.map((step, index) => (
      <div key={step.id} className="flex flex-col items-center space-y-2">
        <div
          className={`w-8 h-8  flex items-center justify-center rounded-full border-2 border-[#e6b800] text-xs  font-extrabold ${
            index === manpowerTimeline.length 
              ? "bg-[#e6b800] text-black"
              : "bg-gray-900 text-white"
          }`}
        >
          {index + 1}
        </div>
        <p className="text-xs  font-bold text-center whitespace-nowrap">{step.title}</p>
        {index < manpowerTimeline.length && (
          <div className="h-1 sm:w-12 md:w-16 lg:w-24 bg-[#e6b800]"></div>
        )}
      </div>
    ))}
  </div>
</div>



      {/* Vertical Timeline */}
      <div className="w-full mx-auto px-4 lg:w-11/12">
        <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-center mb-8 uppercase">
          Mobilization Process
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
          {mobilizationTimeline.map((step, index) => (
            <div
              key={step.id}
              className="flex items-start bg-gray-900 border-l-4 border-[#e6b800] p-6 rounded-lg shadow-md hover:scale-[1.02] transition-all duration-300"
            >
              {/* Step Number */}
              <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 p-4 text-lg lg:text-xl rounded-full mr-6 shadow-md bg-[#e6b800] text-black font-bold">
                {index + 1}
              </div>

              {/* Content Section */}
              <div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2">{step.title}</h3>
                <p className="text-gray-400 text-md sm:text-lg">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Timeline;
